import { gql } from '@apollo/client'

export const SHOP_APPLIED_GIFT_CARD_FRAGMENT = gql`
  fragment ShopAppliedGiftCard on ShopAppliedGiftCard {
    cardLast4
    id
  }
`
